export enum HttpErrorHandlerType {
  NO_EMIT = 'NO_EMIT',
}
